(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-template"]) return;
  try {
    

/* Bind a change event to the dropdown */
$('#paginateBy').on('change', function(){

  /* Get the current value. Some value validation could be added here (but we don't) */
  var val = $(this).val();

  /* Send the value as a cart attribute via the AJAX API */
  $.ajax({
    type: "POST",
    url: '/cart.js',
    data: {"attributes[pagination]": val}, /* We are using an attribute named "pagination" */
    success: function(d){
      window.location.reload(); 
    },
    dataType: 'json'
  });
});


  } catch(e) { console.error(e); }
})();

})();
